import React from "react"
import {
  Box,
  Grid,
  Container,
  Typography,
  Card,
  CardMedia,
  CardHeader,
  useTheme,
  CardContent,
  Paper,
  useMediaQuery,
} from "@material-ui/core"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import styled from "styled-components"
import Rating from "@material-ui/lab/Rating"
import StarBorderIcon from "@material-ui/icons/StarBorder"
import { gql, useSubscription } from "@apollo/client"

const SSlider = styled(Slider)`
  .slick-slide div {
    outline: none;
  }

  .slick-slide > div {
    height: 100%;
  }

  .slick-slide > div > div {
    height: 100%;
  }

  .slick-slide > div > div > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .slick-slide > div > div > div > quote {
    flex: 1;
  }

  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: inherit !important;
  }

  .slick-dots {
    bottom: -35px !important;

    li {
      margin: 0 1px;

      button:before {
        font-size: 10px !important;
      }
    }
  }
`

const NEWS = gql`
  subscription news {
    news {
      id
      content
      logo
      rating
      name
    }
  }
`

const Comp = () => {
  let theme = useTheme()
  let smaller = useMediaQuery(theme.breakpoints.down("md"))

  const { data, loading } = useSubscription(NEWS)

  if (loading) {
    return <></>
  }

  return (
    <Box py={[8, 16]} textAlign="center" component={Paper} elevation={0} square>
      <Container maxWidth="xl" disableGutters={smaller}>
        <Grid container>
          <Grid item xs={12}>
            <Container maxWidth="md">
              <Typography
                variant="h3"
                component="h2"
                align="center"
                gutterBottom
              >
                Custo in the News
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                align="center"
                paragraph
                gutterBottom
              >
                See what leading publications have said about our unique
                approach to furniture design
              </Typography>
            </Container>
            <Box my={[8]}>
              <SSlider
                {...{
                  initialSlide: 0,
                  autoplay: true,
                  autoplaySpeed: 4000,
                  pauseOnHover: true,
                  speed: 500,
                  dots: true,
                  infinite: true,
                  slidesToShow: 3,
                  centerMode: true,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  focusOnSelect: true,
                  responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                      },
                    },
                    {
                      breakpoint: 800,
                      settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                      },
                    },
                  ],
                }}
              >
                {data.news.map(c => (
                  <Box
                    p={1}
                    style={{
                      minWidth: "150px",
                      maxWidth: "90vw",
                    }}
                  >
                    <Card variant="outlined">
                      <CardHeader
                        component="quote"
                        titleTypographyProps={{
                          variant: "h6",
                          gutterBottom: true,
                          paragraph: true,
                          color: "secondary",
                          style: { fontWeight: 600, fontStyle: "italic" },
                        }}
                        title={`“${c.content}”`}
                      ></CardHeader>
                      <CardMedia
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          padding: 20,
                        }}
                        title={c.name}
                      >
                        <img
                          alt=""
                          src={c.logo}
                          style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                          }}
                        />
                      </CardMedia>
                      {c.rating && (
                        <CardContent>
                          <Rating
                            value={c.rating}
                            readOnly
                            precision={0.5}
                            emptyIcon={<StarBorderIcon fontSize="inherit" />}
                          />
                        </CardContent>
                      )}
                    </Card>
                  </Box>
                ))}
              </SSlider>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Comp
